import { AntDesign } from "@expo/vector-icons";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { View, Text, Pressable } from "react-native";
import MaskInput from "react-native-mask-input";
import Animated, { FadeOut, FadeIn } from "react-native-reanimated";

import ButtonRadio from "@/components/button/ButtonRadio";

export interface FiltersOptions {
  status?: string;
  type?: string;
  query?: string;
  date?: string;
}

interface Props {
  onClose: () => void;
  setFilters: (filters: FiltersOptions) => void;
}

export function Filters(props: Props) {
  const [statusSelected, setStatusSelected] = useState("");
  const [typeSelected, setTypeSelected] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { t } = useTranslation();

  return (
    <Animated.View
      entering={FadeIn.delay(100)}
      exiting={FadeOut.delay(100)}
      className="flex-1 bg-gray rounded-md border border-midgray p-4 gap-4 items-center"
    >
      <Pressable className="absolute top-3 left-3" onPress={props.onClose}>
        <AntDesign name="close" size={16} color="black" />
      </Pressable>
      <Text className="text-lg font-medium">
        {t("management/filters:title")}
      </Text>
      <View className="items-center w-full">
        <Text className="text-base mb-2">
          {t("management/filters:sections.status.title")}
        </Text>
        <View className="w-full items-start justify-start">
          <ButtonRadio
            label={t(
              "management/filters:sections.status.options.active"
            ).toUpperCase()}
            value="ACTIVE"
            currentSelected={statusSelected}
            setValue={setStatusSelected}
          />
          <ButtonRadio
            label={t(
              "management/filters:sections.status.options.pending"
            ).toUpperCase()}
            value="PENDING"
            currentSelected={statusSelected}
            setValue={(value: string) => setStatusSelected(value)}
          />
          <ButtonRadio
            label={t(
              "management/filters:sections.status.options.closed"
            ).toUpperCase()}
            value="CLOSED"
            currentSelected={statusSelected}
            setValue={setStatusSelected}
          />
          <ButtonRadio
            label={t(
              "management/filters:sections.status.options.frozen"
            ).toUpperCase()}
            value="FROZEN"
            currentSelected={statusSelected}
            setValue={setStatusSelected}
          />
          <ButtonRadio
            label={t(
              "management/filters:sections.status.options.edd"
            ).toUpperCase()}
            value="EDD"
            currentSelected={statusSelected}
            setValue={setStatusSelected}
          />
        </View>
      </View>
      <View className="items-center w-full">
        <Text className="text-base mb-2">
          {t("management/filters:sections.type.title")}
        </Text>
        <View className="w-full items-start justify-start">
          <ButtonRadio
            label={t(
              "management/filters:sections.type.options.individual"
            ).toUpperCase()}
            value="INDIVIDUAL"
            currentSelected={typeSelected}
            setValue={setTypeSelected}
          />
          <ButtonRadio
            label={t(
              "management/filters:sections.type.options.corporation"
            ).toUpperCase()}
            value="CORPORATION"
            currentSelected={typeSelected}
            setValue={setTypeSelected}
          />
        </View>
      </View>
      <View className="items-center w-full">
        <Text className="text-base mb-2">
          {t("management/filters:sections.onboarddate.title")}
        </Text>
        <View className="flex-col w-full">
          <Text className="text-sm p-2">{t("common:terms.startdate")}</Text>
          <MaskInput
            className="w-full border border-midgray rounded-md p-2 text-sm bg-white1"
            placeholder="DD/MM/YYYY"
            placeholderTextColor="#A0A0A0"
            value={startDate}
            onChangeText={(masked, unmasked) => {
              setStartDate(masked);
            }}
            mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
          />
        </View>
        <View className="flex-col w-full">
          <Text className="text-sm p-2">{t("common:terms.enddate")}</Text>
          <MaskInput
            className="w-full border border-midgray rounded-md p-2 text-sm bg-white1"
            placeholder="DD/MM/YYYY"
            placeholderTextColor="#A0A0A0"
            value={endDate}
            onChangeText={(masked, unmasked) => {
              setEndDate(masked);
            }}
            mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
          />
        </View>
      </View>
      <Pressable
        className="bg-purple1 hover:bg-purple3 rounded-md p-2 w-full items-center"
        onPress={() =>
          props.setFilters({
            status: statusSelected,
            type: typeSelected,
            date: `${startDate} - ${endDate}`,
          })
        }
      >
        <Text className="text-white1 font-light text-base">
          {t("common:button.apply")}
        </Text>
      </Pressable>
    </Animated.View>
  );
}
